import {Component, Inject} from '@angular/core';
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {MatButtonModule} from "@angular/material/button";
import {PlayersService} from "../../../services/players.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SnackbarService} from "../../../services/snackbar.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {NgIf} from "@angular/common";
import {IPlayerSuspension} from "../../../interfaces/player/IPlayerSuspension";
import {Observable} from "rxjs";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IUpdatePlayerSuspensionStatus} from "../../../interfaces/player/IUpdatePlayerSuspensionStatus";

@Component({
  selector: 'app-update-player-suspension-status',
  standalone: true,
  imports: [
    DialogBaseComponent,
    MatButtonModule,
    NgIf
  ],
  templateUrl: './update-player-suspension-status.component.html',
  styleUrl: './update-player-suspension-status.component.css'
})
export class UpdatePlayerSuspensionStatusComponent {

  public uiState: UIStateEnum = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {suspension: IPlayerSuspension, game: IGameQueryResult},
              private playerService: PlayersService,
              private activeUserService: ActiveUserService,
              private snackBarService: SnackbarService,
              private errorHandlingService: ErrorHandlingService,
              private dialogRef: MatDialogRef<UpdatePlayerSuspensionStatusComponent>) {
  }

  public updateSuspensionStatus(shouldResolve: boolean) {
    this.uiState = UIStateEnum.ShowLoading;

    let updateSuspensionCall = this.updatePlayerSuspensionStatus(shouldResolve);
    const action = shouldResolve ? 'resolve' : 'unresolve';

    updateSuspensionCall.subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar(`Successfully ${action}d suspension`);
        this.dialogRef.close(true);
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayDialogLevelErrorMessage(`Failed to ${action} suspension`, err)
      }
    })
  }

  public resolveSuspension() {
    this.updateSuspensionStatus(true);
  }

  public unresolveSuspension() {
    this.updateSuspensionStatus(false);
  }

  private updatePlayerSuspensionStatus(isResolving: boolean): Observable<any> {
    let command: IUpdatePlayerSuspensionStatus = {
      AdminId: this.activeUserService.activeUser().Id,
      GameId: this.data.game.Id,
      PlayerId: this.data.suspension.PlayerId,
      SuspensionId: this.data.suspension.Id,
      IsResolving: isResolving
    }

    return this.playerService.updatePlayerSuspensionStatus(command);
  }
}
